import { APP_CONSTANTS } from "@/config";
import { useNotificationIdentity } from "@/hooks/notifications/use-notification-identity";
import { httpRequest } from "@/lib/axios";
import { SettingsTenant } from "@/types";
import { useQuery } from "@tanstack/react-query";

export function useFetchSettingsTenantQuery() {
  const { tenantId, userId } = useNotificationIdentity();
  const selected = localStorage.getItem(APP_CONSTANTS.COMPANY_LOCAL_STORAGE_KEY);
  const token = localStorage.getItem(APP_CONSTANTS.AUTH_ACCESS_TOKEN_LOCAL_STORAGE_KEY);
  const identityReady = Boolean(tenantId && (!selected || selected === tenantId));
  const identityMatches = () =>
    localStorage.getItem(APP_CONSTANTS.COMPANY_LOCAL_STORAGE_KEY) === selected &&
    localStorage.getItem(APP_CONSTANTS.AUTH_ACCESS_TOKEN_LOCAL_STORAGE_KEY) === token;
  const query = useQuery({
    queryKey: ["get-settings", tenantId, userId],
    queryFn: async ({ signal }) => {
      if (!identityReady || !identityMatches()) throw new Error("Session changed");
      const response = await httpRequest.get<SettingsTenant>("/get-settings", { signal });
      if (!identityMatches()) throw new Error("Session changed");
      return response;
    },
    keepPreviousData: false,
    enabled: identityReady,
    retry: false,
  });

  return {
    ...query,
    identityReady,
    data: identityReady ? query.data?.data : undefined,
  };
}
